<template>
  <v-container v-if="$store.getters.user" class="test_red">
    <v-row justify="center" no-gutters class="test_blue">
      <v-col v-if="!showForm" cols="12" md="10" lg="8" class="test_yellow">
        <v-list v-if="$store.getters.isLoading">
          <v-list-item class="list-group-item my-2 px-5">
            <v-list-item-content>
              <v-skeleton-loader type="list-item-avatar-two-line" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-else>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="list-group-item my-2 px-5"
          >
            <v-list-item-icon class="mx-0 mr-4 d-flex align-center">
              <v-img
                :src="getImageSrc(item.brand)"
                style="image-rendering: optimizeSpeed"
                contain
                class="img-banner-container"
                width="45px"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular indeterminate color="primary" />
                  </v-row>
                </template>
              </v-img>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>
                <span v-text="getCardNumber(item)" />
                <v-chip
                  v-if="item.isDefault"
                  class="ml-5"
                  label
                  v-text="$t('general.default')"
                />
              </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action v-ripple>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon v-text="'mdi-dots-vertical-circle-outline'" />
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item-group color="primary">
                    <v-list-item @click="setDefault(item)">
                      <v-list-item-title
                        v-text="$t('customerProfile.setAsDefault')"
                      />
                    </v-list-item>
                    <v-list-item @click="deleteCard(item)">
                      <v-list-item-title v-text="$t('general.delete')" />
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col
        v-else
        cols="12"
        md="10"
        lg="9"
        class="test_yellow form-background"
      >
        <v-container>
          <v-row justify="center">
            <div
              style="
                max-width: 400px;
                width: 100%;
                height: 100%;
                margin-top: 30px;
              "
            >
              <StripeCardInput
                :stripe="stripe"
                @handleError="handleError"
                @handleCompleteCard="handlerConfirmCardInput"
              />
            </div>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="8" md="8">
              <v-row justify="space-around">
                <v-col cols="5">
                  <ButtonSuccess
                    title="Add card"
                    :valid="valid"
                    @click="handlerSaveCard()"
                  />
                </v-col>
                <v-col cols="5">
                  <ButtonCancel @click="closeCardForm()" />
                </v-col>

                <v-col cols="10">
                  <span
                    class="notice"
                    v-text="
                      $t('customerProfile.noticeCard', {
                        appName: $store.getters.appInfo.appName,
                      })
                    "
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-if="!showForm" justify="center" no-gutters class="test_blue">
      <v-btn
        :loading="isLoading"
        :disabled="isLoading"
        x-large
        color="primary"
        rounded
        @click="showCardForm()"
      >
        <v-icon left v-text="'mdi-plus'" />
        <span class="btn" v-text="$t('customerProfile.addNewCard')" />
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import StripeCardInput from "@/views/front/checkout/components/StripeCardInput.vue";
import defaultCardImage from "@/assets/img/creditcards/default.png";
import visaImage from "@/assets/img/creditcards/visa.png";
import mastercardImage from "@/assets/img/creditcards/mastercard.png";
import amexImage from "@/assets/img/creditcards/amex.png";
import discoverImage from "@/assets/img/creditcards/discover.png";
import jcbImage from "@/assets/img/creditcards/Jcb.png";
import dinersclubImage from "@/assets/img/creditcards/diners.png";
import unionpayImage from "@/assets/img/creditcards/unionpay.png";

export default {
  name: "PaymentMethod",
  components: {
    StripeCardInput,
  },
  data: () => ({
    items: null,
    showForm: false,
    infoCard: null,
    stripe: null,
    valid: false,
    isCardFilled: false,
    isLoading: false,
    cardImages: {
      visa: visaImage,
      mastercard: mastercardImage,
      amex: amexImage,
      discover: discoverImage,
      jcb: jcbImage,
      dinersclub: dinersclubImage,
      unionpay: unionpayImage,
    },
  }),
  beforeMount() {
    this.initializeStripe();
  },
  beforeCreate() {
    this.initializeStripe();
  },
  mounted() {
    this.loadPaymentsMethods();
  },
  methods: {
    initializeStripe() {
      if (this.$store.getters.appInfo) {
        // eslint-disable-next-line no-undef
        this.stripe = Stripe(this.$store.getters.appInfo.publishableKey);
      }
    },
    getImageSrc(brand) {
      if (!brand) return defaultCardImage;

      const brandLower = brand.toLowerCase();
      return this.cardImages[brandLower] || defaultCardImage;
    },
    getCardNumber(item) {
      return this.$store.getters.appInfo.paymentProvider === "flatpay"
        ? item.lastFourDigit
        : `**** **** **** ${item.lastFourDigit}`;
    },
    async getFlatPaySessionId() {
      try {
        const response = await axios.get(
          "/users/profiles/payment/pm_accountSession"
        );
        return response.data;
      } catch (e) {
        this.showErrorAlert();
      }
    },
    async savePayMethod(paymentMethod) {
      try {
        console.log("id", paymentMethod.id);
        let form = new Form({
          payment_method: paymentMethod.id,
        });
        const { data } = await form.post("/users/profiles/payment/pm_account");
        await this.loadPaymentsMethods();
        Toast.fire({
          icon: "success",
          title: data.message,
        });
        this.resetCardForm();
      } catch (e) {
        this.handlePaymentMethodError(e);
      }
    },
    async showCardForm() {
      if (this.$store.getters.appInfo.paymentProvider === "flatpay") {
        this.isLoading = true;
        const res = await this.getFlatPaySessionId();
        const sessionId = res.id;
        this.isLoading = false;
        try {
          const Reepay = await this.$loadReepay();
          const rp = new Reepay.ModalCheckout(sessionId);
          rp.addEventHandler(
            // eslint-disable-next-line no-undef
            Reepay.Event.Accept,
            async function (data) {
              console.log("Success", data);
              await this.savePayMethod({
                id: data.payment_method,
                customer: data.customer,
              });
            }.bind(this)
          );
        } catch (error) {
          console.error("Failed to load Reepay SDK", error);
        }
      } else {
        this.showForm = true;
        this.isLoading = false;
      }
    },
    closeCardForm() {
      setTimeout(() => {
        this.showForm = false;
      }, 100);
    },
    async handlerSaveCard() {
      this.$store.dispatch("loading/start");
      const { paymentMethod, error } = await this.stripe.createPaymentMethod({
        type: "card",
        card: this.$store.getters.cardInputElement.cardNumberElement,
      });

      if (error) {
        this.showErrorAlert(error.message);
      } else {
        await this.savePayMethod(paymentMethod);
      }
      this.$store.dispatch("loading/done");
    },
    handlerConfirmCardInput() {
      this.valid = true;
      this.isCardFilled = true;
    },
    handleError(values) {
      this.valid = values.value;
      this.isCardFilled = values.value;
    },
    async loadPaymentsMethods() {
      this.$store.dispatch("loading/start");
      const { data } = await axios.get("/users/profiles/payment/method");
      this.items = data.data;
      this.$store.dispatch("loading/done");
    },
    async deleteCard(datas) {
      const { value: result } = await Swal.fire({
        title: this.$t("general.delete"),
        html: `${this.$t(
          "customerProfile.deletePaymentMethod"
        )} <b>${this.getCardNumber(datas)}</b>?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      if (result) {
        await this.executePaymentMethodAction(
          `/users/profiles/payment/method/${datas.id}`,
          "delete"
        );
        await this.loadPaymentsMethods();
      }
    },
    async setDefault(datas) {
      let form = new Form({
        paymentAccountId: datas.id,
      });
      await this.executePaymentMethodAction(
        "/users/profiles/payment/default",
        "post",
        form
      );
      await this.loadPaymentsMethods();
    },
    async executePaymentMethodAction(url, method, form = null) {
      try {
        this.$store.dispatch("loading/start");
        const { data } = await (method === "delete"
          ? axios.delete(url)
          : form.post(url));
        Toast.fire({
          icon: "success",
          title: data.message,
        });
      } catch (e) {
        this.handlePaymentMethodError(e);
      } finally {
        this.$store.dispatch("loading/done");
      }
    },
    showErrorAlert(message = this.$t("errors.COMMON_ERROR")) {
      Swal.fire({
        title: this.$t("errors.ERROR"),
        html: message,
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
    },
    handlePaymentMethodError(e) {
      let errorMessage = e.response
        ? e.response.data.message
        : this.$t("errors.COMMON_ERROR");
      this.showErrorAlert(errorMessage);
    },
    resetCardForm() {
      this.showForm = false;
      this.infoCard = null;
      this.isCardFilled = false;
    },
  },
};
</script>

<style scoped>
.notice {
  font-size: 0.875rem;
  color: #6b7280;
}
.form-background {
  background: #f9fafb;
}
</style>
